import React from "react";
import { observer } from "mobx-react-lite";
import { useRootStore } from "../../../../store/contexts";
import { ErrorDialog } from "../../../../common/controls";
import { AiSearchToolCallListStore } from "../../store/AiSearchToolCallListStore";

type AiSearchToolCallListDialogsProps = {
  store: AiSearchToolCallListStore;
};

/**
 * Componente que agrupa todos los dialogs del listado de AiSearchToolCall.
 * Separado para mantener AiSearchToolCallListPage más limpio.
 */
export const AiSearchToolCallListDialogs: React.FC<AiSearchToolCallListDialogsProps> =
  observer(({ store }) => {
    const { langStore } = useRootStore();

    return (
      <>
        {/* Dialog de error genérico */}
        <ErrorDialog
          open={store.errorDialogOpened}
          title={store.errorTitle || langStore.errorTitle}
          description={store.errorDescription}
          onClose={() => store.closeErrorDialog()}
        />
      </>
    );
  });
